import { loginModule } from "@/modules/auth/modules/login/store";
import { otpModule } from "@/modules/auth/modules/otp/store";
import { registerModule } from "@/modules/auth/modules/register/store";
import { forgetPassModule } from "@/modules/auth/modules/forget-pass/store";
export const authModule = {
  namespaced: true,
  modules: {
    forgetPass: forgetPassModule,
    register: registerModule,
    login: loginModule,
    otp: otpModule,
  },
};
